'use client';

import { FooterNavigation } from '@goodneighbor/ui';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

const footerLogo = {
  src: '/icons/gnda-logo_dark.svg',
  alt: 'Good Neighbor Day America',
  href: '/'
};

const hiddenPaths = [
  '/',
  '/events',
  '/partner',
  '/volunteer',
  '/log-in',
  '/sign-up',
  '/forgot',
  '/reset-password'
];

export default function Footer() {
  const pathname = usePathname();
  const isHidden = hiddenPaths.some((path) => pathname?.startsWith(path));

  if (isHidden) {
    return null;
  }

  return <FooterNavigation logo={footerLogo} LinkComponent={Link} />;
}
